import { Box, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import { FC } from "react";
import { PaymentSettingsProps } from "./payment-settings.types";

const PaymentSettings: FC<PaymentSettingsProps> = ({
  alphaReferralPaymentBps,
  museReferralPaymentCents,
  bankAccountCredentials,
  rightAddon,
}) => {
  return (
    <Box>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography variant="h6" gutterBottom>
          Payment Settings
        </Typography>
        {rightAddon}
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          {museReferralPaymentCents !== undefined && (
            <TextField
              fullWidth
              label="Muse Referral Payment"
              value={`$ ${(museReferralPaymentCents / 100).toFixed(2)}`}
              InputProps={{ readOnly: true }}
              variant="filled"
              sx={{ input: { color: "#fff" }, label: { color: "#ccc" } }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {alphaReferralPaymentBps !== undefined && (
            <TextField
              fullWidth
              label="Man Referral Payment"
              value={`% ${alphaReferralPaymentBps / 100}`}
              InputProps={{ readOnly: true }}
              variant="filled"
              sx={{ input: { color: "#fff" }, label: { color: "#ccc" } }}
            />
          )}
        </Grid>
      </Grid>
      {!!bankAccountCredentials && (
        <Box sx={{ mt: 1 }}>
          <Typography gutterBottom>Bank account credentials</Typography>
          <Paper
            variant="outlined"
            sx={{ p: 1, bgcolor: "#222", color: "#ccc" }}
          >
            <Typography whiteSpace="pre-line">
              {bankAccountCredentials}
            </Typography>
          </Paper>
        </Box>
      )}
    </Box>
  );
};

export { PaymentSettings };
